import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { crud } from '@/redux/crud/actions';
import { selectListItems } from '@/redux/crud/selectors';
import { Form, notification } from 'antd'; // Agregamos notification

/**
 * Custom Hook: useCrudDirect
 * Maneja la lógica centralizada para operaciones CRUD interactivas.
 */
export function useCrudDirect(entity) {

  const tenant = useSelector((state) => state.auth.current.tenant);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  // --- ESTADOS LOCALES ---
  const [selectedItem, setSelectedItem] = useState(null);
  const [isAdding, setIsAdding] = useState(false);

  // --- CONFIGURACIÓN ---
  const defaultOptions = { 
    page: 1, 
    limit: 10,
    company: 1 
  };

  
  // --- SELECTORES ---
  const reduxData = useSelector(selectListItems);
  const items = reduxData?.result?.items || [];

  // --- EFECTOS ---
  // Carga inicial al montar el componente o cambiar la entidad
  useEffect(() => {
    dispatch(crud.list({ entity, tenant:tenant ,options: defaultOptions }));
  }, [dispatch, entity]);

  // --- MANEJADORES DE EVENTOS ---

  const onFinish = async (values) => {

    const companyId = 1;
   
    const jsonData = {
      ...values,
      company: companyId
    };

    try {
      if (isAdding) {
        // Operación: CREAR
        const response = await dispatch(crud.create({ 
          entity, 
          tenant,
          jsonData, 
          options: { params: { company: companyId } } 
        }));
        
        // Dependiendo de tu config de Redux, el payload real puede estar aquí
        const data = response?.payload || response?.data || response;
        if (data?.message || data?.success) {
          notification.success({ message: data?.message || 'Registro creado exitosamente' });
        }
        
        setIsAdding(false);
      } else {
        // Operación: ACTUALIZAR
        if (!selectedItem?.id) {
          console.error(`No hay un registro de [${entity}] seleccionado para actualizar.`);
          return;
        }
        
        const response = await dispatch(crud.update({ 
          entity, 
          tenant,
          id: selectedItem.id, 
          jsonData, 
          options: { params: { company: companyId } } 
        }));
        
        // Extraemos la información real del Thunk
        const data = response?.payload || response?.data || response;
        console.log("Respuesta del servidor en el UPDATE:", data);
        
        if (data?.message) {
           notification.success({ message: data.message });
        } else if (data?.success) {
           notification.success({ message: 'Registro actualizado exitosamente' });
        }
      }

      // Refresco de datos tras cualquier operación exitosa
      dispatch(crud.list({ entity, tenant, options: defaultOptions }));
      
    } catch (error) {
      console.error("Error ejecutando el onFinish:", error);
      notification.error({ message: 'Error al procesar la solicitud' });
    }
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    setIsAdding(false);
    form.setFieldsValue(item);
  };

  const handleAddNew = () => {
    setIsAdding(true);
    setSelectedItem(null);
    form.resetFields();
  };

  // --- API DEL HOOK ---
  return {
    form,
    items,
    selectedItem,
    isAdding,
    setIsAdding,
    setSelectedItem,
    onFinish,
    handleSelectItem,
    handleAddNew
  };
}